module.exports = __webpack_public_path__ + "static/media/spec_vitals.7de1f37c.png";